  <div class="container-fluid sell_dash">
        <div class="wrapper">
            <div class="row">
              <app-sidemenu></app-sidemenu> 
              <section class="right">
              	<app-sellheader></app-sellheader>
              	<div class="right-middle row justify-content-center">
                   <div class="col-md-10 col-lg-8 col-xl-11 col-10 col-sm-10">
                      <div class="row card-market">
	                    <div class="col-md-6 col-lg-6 col-xl-3 col-6 col-sm-6 card-mob">
	                        <div class="card data-card item-card">
	                            <div class="info"><a href="#" (mouseenter)="dataInfo($event)"><img src="./assets/image/info.svg" class="mr-2 mt-2"></a></div>
	                            <div class="card-heading">
	                                <p>DATA ASSETS</p>
	                            </div>
	                            <div class="card-bottom">
	                                <button type="button" class="termcondition">EXPLORE</button>
	                            </div>
	                        </div>
	                        <div class="card-circle data-circle">
	                            <p class="big-circle"></p>
	                            <p class="small-circle"></p>
	                        </div>
	                    </div>
	                    <div class="col-md-6 col-lg-6 col-xl-3 col-6 col-sm-6 card-mob">
	                        <div class="card ml-card item-card">
	                            <div class="info"><a href="#" (mouseenter)="algoInfo($event)"><img src="./assets/image/info.svg" class="mr-2 mt-2"></a></div>
	                            <div class="card-heading">
	                                <p>ALGORITHMS</p>
	                            </div>
	                            <div class="card-bottom">
	                                <button type="button" class="algotermcondition">EXPLORE</button>
	                            </div>
	                        </div>
	                        <div class="card-circle data-circle">
	                            <p class="big-circle"></p>
	                            <p class="small-circle"></p>
	                        </div>
	                    </div>
	                    <div class="col-md-6 col-lg-6 col-xl-3 col-6 col-sm-6 card-mob">
	                        <div class="card usecase-card item-card">
	                            <div class="info"><a href="#" (mouseenter)="engineInfo($event)"><img src="./assets/image/info.svg" class="mr-2 mt-2"></a></div>
	                            <div class="card-heading">
	                                <p>ENGINES</p>
	                            </div>
	                            <div class="card-bottom">
	                                <button type="button" class="enginetermcondition">EXPLORE</button>
	                            </div>
	                        </div>
	                        <div class="card-circle data-circle">
	                            <p class="big-circle"></p>
	                            <p class="small-circle"></p>
	                        </div>
	                    </div>
	                    <div class="col-md-6 col-lg-6 col-xl-3 col-6 col-sm-6 card-mob">
	                            <div class="card workflow-card item-card">
	                                <div class="info"><a href="#" (mouseenter)="solutionInfo($event)"><img src="./assets/image/info.svg" class="mr-2 mt-2"></a></div>
	                                <div class="card-heading">
	                                    <p>SOLUTIONS</p>
	                                </div>
	                                <div class="card-bottom">
	                                    <button type="button" class="soltermcondition">EXPLORE</button>
	                                </div>
	                            </div>
	                            <div class="card-circle data-circle">
	                                <p class="big-circle"></p>
	                                <p class="small-circle"></p>
	                            </div>
	                        </div>
                    </div>
                </div>
                <div class="col-md-12 col-lg-10 col-xl-11 col-10 col-sm-10">
                    <div class="card report-data  px-0">
                        <div class="row">
                            <div class="col-md-12 col-lg-12 report-title d-none d-md-block d-lg-block"><span>ANALYTICS</span>
                            <span class="filter">
                            	<a class="filter_show">
                            	<img src="./assets/image/filter-512.png" class="rounded-circle shadow-sm p-1" width="30"></a>
	                            	<div class="kt-radio-list card shadow-sm py-3 px-4 mt-2 filter_analytics d-none">
									     <label class="kt-radio kt-radio--bold kt-radio--success">
											<input type="radio" name="filter_date" value="5" checked> Till Date
											<span></span>
										 </label>
									    <label class="kt-radio kt-radio--bold kt-radio--success">
											<input type="radio" name="filter_date" value="4"> Last 1 Week
											<span></span>
										 </label>
									    <label class="kt-radio kt-radio--bold kt-radio--success">
											<input type="radio" name="filter_date" value="3"> Last 1 Month
											<span></span>
										 </label>
										 <label class="kt-radio kt-radio--bold kt-radio--success">
											<input type="radio" name="filter_date" value="2"> Last 1 Year
											<span></span>
										 </label>
								   </div>
                            </span>
                            </div>
                            <div class="col-md-2 col-lg-2 d-none d-md-none d-lg-block"></div>
                            <div class="col-md-12 col-lg-7 col-12 report-body">
                                <div class="row" style="justify-content: center;">
                                    <div class="col data">
                                        <p>UPLOADS</p>
                                        <span>{{filter_uploads}}GB+</span>
                                    </div>
                                    <div class="hr-line"></div>
                                    <div class="col data">
                                        <p>TRANSACTIONS</p>
                                        <span>{{filter_transactions}}K+</span>
                                    </div>
                                    <div class="hr-line"></div>
                                    <div class=" col data">
                                        <p>SALES</p>
                                        <span>${{filter_sales}}K+</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <img src="./assets/image/analytics.png" alt="shade" id="report-shade" width="100%" height="65%">
                    </div>
                </div>

            	<div class="col-md-12 col-lg-10 col-xl-11 col-10 col-sm-10" id="atlan">
					<div class="row main" >
						<div class="col-md-4 one">
							<div class="row">
							<p class="one-a">DataPitcher’s modern data marketplace stack brings together the best of monetization principles with the power of self-service</p>
							</div>
							<div class="row one-b">
							<p class="b1">Increase Data Exploration by</p>
							<h1 class="b2">75%</h1>
							</div>
						</div>
						<div class="col-md-4 two">
							<p class="a1">Monetization of Data By</p>
							<h1 class="a2">95%</h1>
						</div>
						<div class="col-md-4 three" >
							<div class="row three-a" >
								<p class="a1" >Time to insight accelerated</p>
								<h1 class="a2" >60x</h1>
								</div>
							<div class="row three-b" >
								<p class="b1">Everything you need to manage your data in one place</p>
							</div>
							<div class="row">
								<div class="card px-2 mb-1 mr-1 py-1 atlan_tag">Catalog</div>
								<div class="card px-2 mb-1 mr-1 py-1 atlan_tag">Govern</div>
								<div class="card px-2 mb-1 mr-1 py-1 atlan_tag">Explore</div>
								<div class="card px-2 mb-1 mr-1 py-1 atlan_tag">Experiment</div>
								<div class="card px-2 mb-1 mr-1 py-1 atlan_tag">Orchestrate</div>
								<div class="card px-2 mr-1 py-1 atlan_tag">Monetize</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-12 col-lg-12 col-xl-12 col-sm-12" id="domain">
					<div class="ex2 mt-5">
						<h1>Our top 4 industry segments: Healthcare, Finance, Energy, Education</h1>
					</div>
				</div>
				<div class="col-md-12 col-lg-10 col-xl-11 col-10 col-sm-10">
						<div class="row hover-card-market">
						  <div class="col-md-6 col-lg-6 col-xl-3 col-6 col-sm-6 card-mob">
							<div class="outer-div" (mouseenter)="hovercard()" (mouseleave)="hovercard2()">
								<div class="inner-div" style="background-image: url(assets/image/health.jpg);"></div>
									<div class="info">
										<div class="info_heading">
											<img src="assets/image/healthcare2.png" style="color: white;"><br>
										  <h3>Healthcare</h3>
										</div>
										  <div class="info_content"></div>
									 </div>
							  </div>
					      </div>
						  <div class="col-md-6 col-lg-6 col-xl-3 col-6 col-sm-6 card-mob">
							<div class="outer-div" (mouseenter)="hovercard()" (mouseleave)="hovercard2()">
								<div class="inner-div" style="background-image: url(assets/image/finance.jpeg);"></div>
									<div class="info">
										<div class="info_heading">
											<img src="assets/image/Finance.png" style="color: white;"><br>
										  <h3>Finance</h3>
										</div>
										  <div class="info_content"></div>
									 </div>
							</div>
					      </div>
						  <div class="col-md-6 col-lg-6 col-xl-3 col-6 col-sm-6 card-mob">
							<div class="outer-div" (mouseenter)="hovercard()" (mouseleave)="hovercard2()">
								<div class="inner-div" style="background-image: url(assets/image/energy.jpeg)"></div>
									<div class="info">
										<div class="info_heading">
											<img src="assets/image/Energy.png" style="color: white;"><br>
										  <h3>Energy</h3>
										</div>
										  <div class="info_content"></div>
									  </div>	
							</div>
					      </div>	
						  <div class="col-md-6 col-lg-6 col-xl-3 col-6 col-sm-6 card-mob">
							<div class="outer-div" (mouseenter)="hovercard()" (mouseleave)="hovercard2()">
								<div class="inner-div" style="    background-image: url(assets/image/education.jpeg);"></div>
									<div class="info">
										<div class="info_heading">
											<img src="assets/image/testicon_education.png" style="color: white;"><br>
										  <h3>Education</h3>
										</div>
										  <div class="info_content"></div>
									  </div>
							</div>
					     </div>
						</div>

					</div>
				
					<div class="col-md-12 col-lg-12 col-xl-12  col-sm-12" id="domain">
						<div class="ex2 mt-5">
							<h1>Industry Partnerships & Research Associations</h1>
						</div>
					</div>
					

				<div class="col-md-12 col-lg-10 col-xl-11 col-10 col-sm-10" id="domain">
				    <div class="row">
													<div class="blog-slider">
						  <div class="blog-slider__wrp swiper-wrapper">
						    <div class="blog-slider__item swiper-slide">
						      <div class="blog-slider__img">
						        
						        <img src="assets/image/healthcare.jpg" alt="">
						      </div>
						      <div class="blog-slider__content">
						       
						        <div class="blog-slider__title">Health Care</div>
						        <div class="blog-slider__text">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Recusandae voluptate repellendus magni illo ea animi? </div>
						        <a href="#" class="blog-slider__button">Read more</a>
						      </div>
						    </div>
						    <div class="blog-slider__item swiper-slide">
						      <div class="blog-slider__img">
						        <img src="assets/image/finance.jpeg" alt="">
						      </div>
						      <div class="blog-slider__content">
						        
						        <div class="blog-slider__title">Finance</div>
						        <div class="blog-slider__text">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Recusandae voluptate repellendus magni illo ea animi?</div>
						        <a href="#" class="blog-slider__button">Read more</a>
						      </div>
						    </div>
						    
						    <div class="blog-slider__item swiper-slide">
						      <div class="blog-slider__img">
						        <img src="assets/image/energy.jpg" alt="">
						      </div>
						      <div class="blog-slider__content">
						        
						        <div class="blog-slider__title">Energy</div>
						        <div class="blog-slider__text">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Recusandae voluptate repellendus magni illo ea animi?</div>
						        <a href="#" class="blog-slider__button">Read more</a>
						      </div>
							</div>
							<div class="blog-slider__item swiper-slide">
								<div class="blog-slider__img">
								  <img src="assets/image/education.jpg" alt="">
								</div>
								<div class="blog-slider__content">
								  
								  <div class="blog-slider__title">Education</div>
								  <div class="blog-slider__text">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Recusandae voluptate repellendus magni illo ea animi?</div>
								  <a href="#" class="blog-slider__button">Read more</a>
								</div>
							  </div>
							  <div class="blog-slider__item swiper-slide">
								<div class="blog-slider__img">
								  <img src="assets/image/real-estate.jpg" alt="">
								</div>
								<div class="blog-slider__content">
								  
								  <div class="blog-slider__title">Real-Estate</div>
								  <div class="blog-slider__text">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Recusandae voluptate repellendus magni illo ea animi?</div>
								  <a href="#" class="blog-slider__button">Read more</a>
								</div>
							  </div>
						    
						  </div>
						  <div class="blog-slider__pagination"></div>
						</div>
					</div>
				</div>
				<div class="col-md-12 col-lg-10 col-xl-11 col-10 col-sm-10 pt-3" id="domain">
						<video  height="600" loop autoplay controls>
						  <source src="./assets/video/DP.mp4" type="video/mp4">
						</video>
				</div>
				<!--testing-->

				<!--testing-end-->
            </div>
  </section>  
	     <!-- begin::Sticky Toolbar -->
		 <app-stickytoolbar></app-stickytoolbar>
        <!-- end::Sticky Toolbar -->       
</div>
</div>
</div>



<!-- info modal -->
<div class="modal fade dataInfo" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content infomodal">
    	<div class="kt-portlet kt-portlet--skin-solid">
			<div class="kt-portlet__head kt-portlet__head--noborder data_head">
				<div class="kt-portlet__head-label">
					<span class="kt-portlet__head-icon">
						<img src="./assets/image/Data.png" width="50">
					</span>
					<h3 class="kt-portlet__head-title">
						Data Assets
					</h3>
				</div>
				<div class="kt-portlet__head-toolbar">
					<div class="kt-portlet__head-actions">
						<a class="mr-1">
							<img src="./assets/image/icons/help_icon.png">
						</a>
						<a class="ml-1" data-target="data_classification" data-dismiss="modal">
							<img src="./assets/image/icons/close_icon.png">
						</a>
					</div>
				</div>
			</div>
			<div class="kt-portlet__body">
				Lorem Ipsum is simply dummy text of the printing and typesetting dummy text of the printing dummy text of the printing dummy text of the printing industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled.
			</div>
			</div>
    </div>
  </div>
</div>
<div class="modal fade algoInfo" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content infomodal">
    	<div class="kt-portlet kt-portlet--skin-solid">
			<div class="kt-portlet__head kt-portlet__head--noborder algo_head">
				<div class="kt-portlet__head-label">
					<span class="kt-portlet__head-icon">
						<img src="./assets/image/Algorithm.png" width="50">
					</span>
					<h3 class="kt-portlet__head-title">
						Algorithm
					</h3>
				</div>
				<div class="kt-portlet__head-toolbar">
					<div class="kt-portlet__head-actions">
						<a class="mr-1">
							<img src="./assets/image/icons/help_icon.png">
						</a>
						<a class="ml-1" data-target="data_classification" data-dismiss="modal">
							<img src="./assets/image/icons/close_icon.png">
						</a>
					</div>
				</div>
			</div>
			<div class="kt-portlet__body">
				Lorem Ipsum is simply dummy text of the printing and typesetting dummy text of the printing dummy text of the printing dummy text of the printing industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled.
			</div>
			</div>
    </div>
  </div>
</div>
<div class="modal fade engineInfo" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content infomodal">
    	<div class="kt-portlet kt-portlet--skin-solid">
			<div class="kt-portlet__head kt-portlet__head--noborder engine_head">
				<div class="kt-portlet__head-label">
					<span class="kt-portlet__head-icon">
						<img src="./assets/image/Engine.png" width="50">
					</span>
					<h3 class="kt-portlet__head-title">
						Engine
					</h3>
				</div>
				<div class="kt-portlet__head-toolbar">
					<div class="kt-portlet__head-actions">
						<a class="mr-1">
							<img src="./assets/image/icons/help_icon.png">
						</a>
						<a class="ml-1" data-target="data_classification" data-dismiss="modal">
							<img src="./assets/image/icons/close_icon.png">
						</a>
					</div>
				</div>
			</div>
			<div class="kt-portlet__body">
				Lorem Ipsum is simply dummy text of the printing and typesetting dummy text of the printing dummy text of the printing dummy text of the printing industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled.
			</div>
			</div>
    </div>
  </div>
</div>
<div class="modal fade solutionInfo" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content infomodal">
    	<div class="kt-portlet kt-portlet--skin-solid">
			<div class="kt-portlet__head kt-portlet__head--noborder solution_head">
				<div class="kt-portlet__head-label">
					<span class="kt-portlet__head-icon">
						<img src="./assets/image/Solution.png" width="50">
					</span>
					<h3 class="kt-portlet__head-title">
						Solutions
					</h3>
				</div>
				<div class="kt-portlet__head-toolbar">
					<div class="kt-portlet__head-actions">
						<a class="mr-1">
							<img src="./assets/image/icons/help_icon.png">
						</a>
						<a class="ml-1" data-target="data_classification" data-dismiss="modal">
							<img src="./assets/image/icons/close_icon.png">
						</a>
					</div>
				</div>
			</div>
			<div class="kt-portlet__body">
				Lorem Ipsum is simply dummy text of the printing and typesetting dummy text of the printing dummy text of the printing dummy text of the printing industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled.
			</div>
			</div>
    </div>
  </div>
</div>

